import merge from 'classnames';

import { SvgIconContainer } from '@/components/generic/SvgIconContainer';

import { SvgIconContainerIconProps } from '../types';

export const IconArrowDropUp = ({ classes = {}, onClick }: SvgIconContainerIconProps) => (
  <SvgIconContainer className={classes.container} onClick={onClick} role="img">
    <svg
      className={merge(classes.icon)}
      fill="#CCCCCC"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7 14l5-5 5 5z" />
    </svg>
  </SvgIconContainer>
);
